
<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Lineas de crédito</ModuleHeader>
      <uvDataTable
        :config="config"
        :data="lineasCredito"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uvDataTable>
    </div>
    <modal ref="modalForm" :fullscreen="false" v-model="Dialogs.showModal" :showFooter="false">
      <CreditoForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
        />
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../MainComponents/DataTable.vue";
import CreditoForm from "../LineasCredito/CreditoForm.vue"
import { mapGetters } from "vuex";
export default {
  name: "CreditoCRUD",
  components: {
    uvDataTable,
    CreditoForm
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      Dialogs:{
        sync:false,
        showModal: false,
      },
      dataLineas:[],
      config: {
        selectableRow: true,
        orderByCol:{Field:"ncdt",Type:"Asc"},
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addLinea",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarLinea",
            require: true,
          },
          {
            text: "Detalle Linea de Crédito",
            icon: "lni lni-pencil-alt",
            buttonId: "detalleLinea",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "softDeleteLinea",
            require: true,
          },
        ],
        fields: [
          {
            text:'Cliente',
            value:'clienteName',
          },
          {
            value:'ncdt',
            text: "Número de Crédito",
          },
          {
            text:'Limite de Crédito',
            value: "lcdt",
            format: (row) => {
              return this.$pgsHelper.formatNumber(row['lcdt']);
            }
          },
          {
            text:'Tasa Interés Anual',
            value: "tia",
            format: (row) => {
              return row['tia'] + "%"
            }
          },
          {
            value:'dpgo',
            text: "Día pago",
          },
          {
            value:'dcte',
            text: "Día corte",
          },
        ],
      },
      Catalogos:{
        PlanesMembresias:[],
        data_membresias:[],
      },
      aux:{
        membresiaToSync:{},
      },

    };
  },
  computed: {
    ...mapGetters("dataLists",["getBNK_LineasCredito"]),
    lineasCredito(){
      let data = JSON.parse(JSON.stringify(this.getBNK_LineasCredito));
      data.forEach((el)=>{
        let cliente = this.$pgsHelper.getById(this.$store.getters.getClientes,'id',el.clnt);
        el.cliente = cliente;
        el.clienteName = cliente.Apellidos +' '+ cliente.Nombres;
      })
      return data;
    },
    clients() {
      let clientes = {};
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes[element.id]=element;
        }
      });
      return clientes;
    },
  },
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createLineaCredito(data);
      } else if (doAction == "EDIT") {
        this.editarLineaCredito(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addLinea") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Linea de Crédito");
        this.clientAdd = {
          nombre: "",
          apellidos: "",
          correo: "",
          telefono: "",
          grupo: "",
        };
        this.toggleModal(true);
      }
      if (buttonId == "editarLinea") {
        this.idSelected = idSelected[0];
        const membresia = this.$pgsHelper.getById(
          this.lineasCredito,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = membresia;
        this.$refs.modalForm.setTitle("Linea de Crédito");
        this.toggleModal(true);
      }
      if(buttonId =='detalleLinea'){
        this.$router.push({ path: "detail/"+idSelected[0] });
      }
      if (buttonId == "softDeleteLinea") {
        this.softDeleteLineaCredito(idSelected[0]);
      }
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    syncBiometric(){
      this.aux.membresiaToSync;
      this.Dialogs.sync = false;
    },
    createLineaCredito(data) {
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"la linea de crédito",
          route:'BNK-LineasCredito-createLineaCredito',
          data:data,
          onSuccess:(res)=>{
            this.toggleModal(false);
            const targetId = (res && res.data && res.data.id) || (res && res.data && res.data.data ? res.data.data.id : data.id || data.Id);
            this.$pgsHelper.writeLog({
              Evento: "LINEA_CREDITO_CREATE",
              Mensaje: "Línea de crédito creada",
              reference: { id: targetId, tp: "BNK-LineaCredito", al: "LINEA DE CREDITO" },
              data: data
            });
          }
        }
      );
    },
    editarLineaCredito(data) {
      this.$alert.alertConfirm(
        {
          action:"editar",
          obj:"la linea de crédito",
          route:'BNK-LineasCredito-updateLineaCredito',
          data:data,
          onSuccess:()=>{
            this.toggleModal(false);
            this.$pgsHelper.writeLog({
              Evento: "LINEA_CREDITO_EDIT",
              Mensaje: "Línea de crédito editada",
              reference: { id: data.id || data.Id, tp: "BNK-LineaCredito", al: "LINEA DE CREDITO" },
              data: data
            });
          }
        }
      );
    },
    softDeleteLineaCredito(id) {
      const deletedObject = this.$pgsHelper.getById(this.lineasCredito, "id", id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm(
        {
          action:"desactivar",
          obj:"la linea de crédito",
          route:'BNK-LineasCredito-sdeleteLineaCredito',
          data:datos,
          onSuccess:()=>{
            this.$pgsHelper.writeLog({
              Evento: "LINEA_CREDITO_DELETE",
              Mensaje: "Línea de crédito desactivada",
              reference: { id: id, tp: "BNK-LineaCredito", al: "LINEA DE CREDITO" },
              data: deletedObject
            });
          }
        }
      );
    },
    toggleModal(open) {
      this.Dialogs.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    /*this.$alert.alert({
      title:"Test",
      subtitle:"Test sunb",
      icon:"success"
    })*/
  },
};
</script>